import { render } from "./MaterialSwitch.vue?vue&type=template&id=0e21f10a"
import script from "./MaterialSwitch.vue?vue&type=script&lang=js"
export * from "./MaterialSwitch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\fchristo.ETAGEN\\Documents\\Adam-Backend\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__